import React from 'react'
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  TextField
} from '@mui/material'
import { Controller, useFormContext, get } from 'react-hook-form'

export const ControlledAutocompleteField = ({
  options = [],
  label,
  name,
  defaultValue,
  helperText,
  onInputChange = () => {},
  isLoading = false,
  disabled = false
}) => {
  const { control, formState } = useFormContext()

  const error = get(formState.errors, name)
  const hasError = error !== undefined

  return (
    <FormControl fullWidth size='small'>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          const handleChange = (_, selected) => {
            onChange(selected?.value)
          }
          return (
            <Autocomplete
              onChange={handleChange}
              name={name}
              filterOptions={x => x}
              options={options}
              onInputChange={onInputChange}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={option => option.value === value}
              loading={isLoading}
              disabled={disabled}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.value}>
                    {option.label}
                  </li>
                )
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  error={hasError}
                  label={label}
                  variant='outlined'
                />
              )}
            />
          )
        }}
      />
      {helperText !== undefined && !hasError && (
        <FormHelperText id={`helper-text-${name}`}>{helperText}</FormHelperText>
      )}
      {error?.message !== undefined && (
        <FormHelperText
          id={`error-helper-text-${name}`}
          error
          style={{ textAlign: 'right', paddingRight: 8 }}
        >
          {error?.message}
        </FormHelperText>
      )}
    </FormControl>
  )
}
